import _extends from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["items", "itemProps", "iconProps", "nameProps", "valueProps", "vertical", "filter", "hideFiltered", "sortByName", "sortByValue", "columns", "colProps", "autoNameWidth", "className"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import classNames from 'classnames';
import { DixuCol } from "../DixuGrid/DixuGrid";
import DixuImage from "../DixuImage/DixuImage";
import DixuText from "../DixuText/DixuText";
import { chunk } from 'lodash';
import React from 'react';
const DixuDescriptionList = _ref => {
  let {
      items,
      itemProps,
      iconProps,
      nameProps,
      valueProps,
      vertical,
      filter,
      hideFiltered,
      sortByName,
      sortByValue,
      columns,
      colProps,
      autoNameWidth,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const classes = classNames('dixu-description-list', className, {
    'dixu-description-list--with-icon': items?.some(item => item.icon),
    [[].concat(vertical).map(e => `dixu-description-list--vertical-${e}`).join(' ')]: vertical,
    'dixu-description-list--auto-name-width': autoNameWidth
  });
  let renderedItems = [...(items || [])];
  if (filter) {
    renderedItems = renderedItems.map(item => {
      const {
        value,
        excludeFromFilter,
        placeholder = '-'
      } = item;
      if (value == null || typeof value === 'string' && !value) {
        if (hideFiltered && !excludeFromFilter) {
          return null;
        }
        return _objectSpread(_objectSpread({}, item), {}, {
          value: placeholder
        });
      }
      return item;
    }).filter(Boolean);
  }
  if (sortByName || sortByValue) {
    renderedItems = renderedItems.sort((a, b) => {
      const {
        name: aName,
        value: aValue
      } = a;
      const {
        name: bName,
        value: bValue
      } = b;
      let nameCompare = 0;
      let valueCompare = 0;
      if (sortByName) {
        nameCompare = aName.localeCompare?.(bName);
      }
      if (sortByValue) {
        valueCompare = aValue.localeCompare?.(bValue);
      }
      return nameCompare || valueCompare;
    });
  }
  const mappedItems = renderedItems.map(item => {
    const {
      icon,
      name,
      value,
      valueSuffix,
      condition,
      excludeFromFilter,
      placeholder = '-',
      itemProps: itemSpecificProps,
      iconProps: iconSpecificProps,
      nameProps: nameSpecificProps,
      valueProps: valueSpecificProps
    } = item;
    const Icon = (() => {
      if (typeof icon === 'string') {
        return /*#__PURE__*/React.createElement(DixuImage, {
          src: icon,
          plain: true
        });
      }
      return icon;
    })();
    const conditionMet = typeof condition === 'undefined' ? true : condition;
    if (!conditionMet && hideFiltered && !excludeFromFilter) {
      return null;
    }
    const itemClassNames = classNames('dixu-description-list__item', itemProps?.className, itemSpecificProps?.className);
    const iconClassNames = classNames('dixu-description-list__icon', iconProps?.className, iconSpecificProps?.className);
    const renderedValue = (() => {
      if (conditionMet) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, value, " ", valueSuffix);
      }
      return placeholder;
    })();
    return /*#__PURE__*/React.createElement("div", _extends({
      key: name
    }, _objectSpread(_objectSpread(_objectSpread({}, itemProps), itemSpecificProps), {}, {
      className: itemClassNames
    })), /*#__PURE__*/React.createElement("dt", {
      className: "dixu-description-list__name"
    }, Icon && /*#__PURE__*/React.createElement("span", {
      className: "dixu-description-list__icon-wrapper"
    }, /*#__PURE__*/React.createElement(DixuText, _extends({
      "aria-hidden": "true"
    }, _objectSpread(_objectSpread(_objectSpread({}, iconProps), iconSpecificProps), {}, {
      className: iconClassNames
    })), Icon)), /*#__PURE__*/React.createElement(DixuText, _objectSpread(_objectSpread({
      font: '3',
      weight: 'medium',
      color: '2-8',
      hyphens: true,
      wrap: true
    }, nameProps), nameSpecificProps), name)), /*#__PURE__*/React.createElement("dd", {
      className: "dixu-description-list__value"
    }, /*#__PURE__*/React.createElement(DixuText, _objectSpread(_objectSpread({
      font: '3',
      weight: 'bold',
      color: '2-8',
      wrap: true,
      whiteSpace: 'pre-line'
    }, valueProps), valueSpecificProps), renderedValue)));
  }).filter(Boolean);
  if (mappedItems.length === 0) {
    return null;
  }
  if (columns) {
    return chunk(mappedItems, Math.ceil(mappedItems.length / columns)).map((columnItems, index) => {
      return /*#__PURE__*/React.createElement(DixuCol, _extends({
        key: index.toString(36)
      }, colProps), /*#__PURE__*/React.createElement("dl", _objectSpread({
        className: classes
      }, rest), columnItems));
    });
  }
  return /*#__PURE__*/React.createElement("dl", _extends({
    className: classes
  }, rest), mappedItems);
};

/**
 * Some prop explanations (it's a bit confusing, I agree):
 *
 * filter
 *   - If true, filter items whose values are falsy, either completely hiding
 *     them or displaying placeholder value, depending on other props.
 *
 * hideFiltered
 *   - If true, completely hide filtered values (see above). Otherwise display
 *     the defined placeholder as value.
 *   - if true, completely hide value if its condition (see below) is false.
 *
 * item -> excludeFromFilter
 *   - Is exluded from actions caused by filtering (see above).
 *   - Is exluded from actions caused by condition (see below).
 *
 * item -> condition
 *   - Condition for displaying the value. This is partly a separate
 *     functionality from filtering (see above). If an item's value is truthy
 *     but it's condition is false, either the defined placeholder is shown as
 *     value or the item is hidden completely (if hideFiltered is true and
 *     excludeFromFilter is false)
 *
 * item -> placeholder
 *   - Value shown if the item is filtered (and hideFiltered is false or
 *     excludeFromFilter is true) or when the item's condition (see above)
 *     is false.
 *
 */

DixuDescriptionList.defaultProps = {
  items: [],
  itemProps: undefined,
  iconProps: undefined,
  nameProps: undefined,
  valueProps: undefined,
  vertical: false,
  filter: false,
  hideFiltered: true,
  sortByName: false,
  sortByValue: false,
  columns: undefined,
  colProps: undefined,
  autoNameWidth: false
};
export default DixuDescriptionList;